import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { ApiService } from './api.service';
import { HttpClient } from '@angular/common/http';
import { Observable, empty } from 'rxjs';
import { tap, map, catchError } from 'rxjs/operators';
import { UserAccount, IUser, INewUserBody, IUserAccount, User, IUpdateUserBody, IUpdateUserAccessToScreensBody, BaseResponse } from '../models';
import { UserService } from './user.service';
@Injectable({
  providedIn: 'root'
})
export class ManageCompanyService {
  //#region constructor
  constructor(private httpClient: HttpClient,
    private userService: UserService) { }
  //#endregion
  //#region Api EndPoints

  public getUsersByCustomer(customerNumber: string): Observable<Array<IUser>> {
    const endPoint = `${ConfigService.APIs.endPoints.MANAGE_COMPANY.GET_USER_ACCOUNT}/${customerNumber}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => response.data),
        tap((accountUsers) => { this.accountUsers = accountUsers }));
  }

  public addNewUser(data): Observable<Array<any>> {   
    const apiEndpoint = `${ConfigService.APIs.endPoints.MANAGE_COMPANY.SAVE_NEW_USER}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
  }
  public updateUserAccount(data: IUpdateUserBody): Observable<Array<UserAccount>> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MANAGE_COMPANY.UPDATE_USER_ACCOUNT}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(tap((userAccount) => this.updateUserAccountL(data)));
  }
  public resetUserPassword(data: any): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MANAGE_COMPANY.RESET_USER_PASSWORD}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(tap((userAccount) => this.updateUserAccountL(data)));
  } 
  public updateUserAccessToScreens(data): Observable<IUser> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.MANAGE_COMPANY.UPDATE_USER_ACCESS_TO_SCREENS}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data)
      .pipe(tap((userAccount) => this.updateUserAccessToScreensLocal(data)));
  }
  //#endregion

  //#region Getter Setter & Member Variables

  selectedCustomer: IUser = new User();
  //#region USER_ACCOUNTS Cache & Operations
  private ACCOUNT_USERS: Array<IUser> = [];
  public get accountUsers(): Array<IUser> {
    if (!this.ACCOUNT_USERS) {
      this.ACCOUNT_USERS = [];
    }
    return this.ACCOUNT_USERS;
  }
  public set accountUsers(userAccounts: Array<IUser>) {
    this.ACCOUNT_USERS = userAccounts;
  }
  public set updateUserAccountData(user: IUser) {
    if (user) {
      const indextemp = this.accountUsers.findIndex(r => r.userId === user.userId);
      const temp = this.accountUsers.find(r => r.userId === user.userId);
      if (temp) {
        this.ACCOUNT_USERS.splice(indextemp, 1, user);
      } else {
        this.ACCOUNT_USERS.push(user);
      }
    }
  }
  public updateUserAccountL(updateUserBody: IUpdateUserBody) {
    //if (updateUserBody) {
    //  const indextemp = this.accountUsers.findIndex(r => r.userId === updateUserBody.userId);
    //  const userTemp = this.accountUsers.find(r => r.userId === updateUserBody.userId);
    //  if (userTemp) {
    //    userTemp.userName=updateUserBody.userName;
    //    userTemp.userFirstName =updateUserBody.userFirstName;
    //    userTemp.userLastName =updateUserBody.userLastName;
    //    userTemp.email =updateUserBody.email;
    //  } 
    //}
  }

  public updateUserAccessToScreensLocal(updateUserAccessToScreensBody: IUpdateUserAccessToScreensBody) {
    if (updateUserAccessToScreensBody) {
      const indextemp = this.accountUsers.findIndex(r => r.userId === updateUserAccessToScreensBody.userId);
      const userTemp = this.accountUsers.find(r => r.userId === updateUserAccessToScreensBody.userId);
      if (userTemp) {
        userTemp.canPlaceOrder = updateUserAccessToScreensBody.canPlaceOrder;
        userTemp.hasInvoiceInquiry = updateUserAccessToScreensBody.hasInvoiceInquiry;
        userTemp.hasAccountSummary = updateUserAccessToScreensBody.hasAccountSummary;
        userTemp.hasManageAddress = updateUserAccessToScreensBody.hasManageAddress;
        userTemp.isActive = updateUserAccessToScreensBody.isActive;
        userTemp.isInAdminRole = updateUserAccessToScreensBody.isInAdminRole;
      }
    }
  }
  //#endregion

  //#endregion



}
